/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 3 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 3 PRO React layouts
import Proyek from "layouts/dashboards/proyek";
import ProfileOverview from "layouts/pages/profile/profile-overview";
import SignInCover from "layouts/authentication/sign-in/cover";
import NewUser from "layouts/pages/users/new-user";

import ProyekBaru from "layouts/pages/proyek/proyek-baru";
import LaporanHarian from "layouts/pages/laporan-harian";
// Material Dashboard 3 PRO React components
import MDAvatar from "components/MDAvatar";

// @mui icons
import Icon from "@mui/material/Icon";

// Images

import { logoutUser } from "actions/AuthAction";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import Detail_Proyek from "layouts/applications/detail-proyek";
import Kurva_S from "layouts/applications/kurva-s";
import Input_Kurva_S from "layouts/applications/input-kurva-s";
import Lapor_Progres from "layouts/applications/lapor-progres";
import Verifikasi_Progres from "layouts/applications/verifikasi-progres";

import KurvaTargetRealisasiProyek from "layouts/pages/kurva-target-realisasi-proyek";

import PerusahaanList from "layouts/pages/lists/perusaan-list";
import UsersList from "layouts/pages/lists/users-list";
import KurvaTargetRealisasi from "layouts/pages/kurva-target-realisasi";
import RekapProgresList from "layouts/pages/lists/rekap-progres-list";
import Map from "layouts/pages/map";
import AdminList from "layouts/pages/lists/admin-list";
import ProyekList from "layouts/pages/lists/proyek-list";

// Import variabel API
import { HOHOLOK_UPLOADS } from "utils";

// Import user data dari utils
import { getUserData } from "utils/userData";

// Ambil user data
const { userStorage, userName, userProfile, userStatus, userJenisPerusahaan } =
  getUserData();

// Komponen Logout custom
function LogoutComponent() {
  const navigate = useNavigate();
  useEffect(() => {
    logoutUser(navigate);
  }, [navigate]);
  return null;
}

const routes = [
  {
    type: "collapse",
    name: userName,
    key: "brooklyn-alice",
    available: true,
    icon: (
      <MDAvatar
        src={
          userProfile
            ? `${HOHOLOK_UPLOADS}${userProfile}?t=${Date.now()}`
            : undefined
        }
        alt={userName}
        size="sm"
      />
    ),
    collapse: [
      {
        name: "My Profile",
        key: "my-profile",
        route: "/pages/profile/profile-overview",
        component: <ProfileOverview />,
        available: true,
      },

      {
        name: "Logout",
        key: "logout",
        route: "/authentication/sign-in/basic",
        component: <LogoutComponent />,
        available: true,
      },
    ],
  },
  { type: "divider", key: "divider-0", available: true },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    available: true,
    collapse: [
      {
        name: "Proyek",
        key: "proyek",
        route: "/dashboards/proyek",
        component: <Proyek />,
        available: true,
      },
    ],
  },
  { type: "title", title: "Pages", key: "title-pages" },
  {
    type: "collapse",
    name: "Pages",
    key: "pages",
    icon: <Icon fontSize="small">image</Icon>,
    available: true,
    collapse: [
      {
        name: "Proyek",
        key: "proyek",
        available: true,
        collapse: [
          {
            name: "Proyek baru",
            key: "proyek-baru",
            route: "/pages/proyek/proyek-baru",
            component: <ProyekBaru />,
            available: userStatus === "admin",
          },
          {
            name: "Daftar Proyek",
            key: "daftar-proyek",
            route: "/pages/proyek/daftar-proyek",
            component: <ProyekList />,
            available: userStatus === "admin",
          },
          {
            name: "Detail Proyek",
            key: "detail-proyek",
            route: "/pages/proyek/detail-proyek",
            component: <Detail_Proyek />,
            available: userStatus === "admin",
          },
          {
            name: "Kurva S",
            key: "kurva-s",
            route: "/pages/proyek/kurva-s",
            component: <Kurva_S />,
            available: userStatus === "admin",
          },
          {
            name: "Input Kurva S",
            key: "input-kurva-s",
            route: "/pages/proyek/input-kurva-s",
            component: <Input_Kurva_S />,
            available: userStatus === "admin",
          },
          {
            name: "Lapor Progres",
            key: "lapor-progres",
            route: "/pages/proyek/lapor-progres",
            component: <Lapor_Progres />,
            //available: true,
            available:
              userStatus === "user" && userJenisPerusahaan === "Kontraktor",
          },
          {
            name: "Verifikasi Progres",
            key: "verifikasi-progres",
            route: "/pages/proyek/verifikasi-progres",
            component: <Verifikasi_Progres />,
            available:
              userStatus === "user" && userJenisPerusahaan != "Kontraktor",
            //available: true,
          },

          {
            name: "Kurva Target Realisasi",
            key: "kurva-target-realisasi",
            route: "/pages/proyek/kurva-target-realisasi",
            component: <KurvaTargetRealisasi />,
            available: true,
          },
          {
            name: "Laporan Harian",
            key: "laporan-harian",
            route: "/pages/proyek/laporan-harian",
            component: <LaporanHarian />,
            available: true,
          },
          {
            name: "Rekap Progres",
            key: "rekap-progres",
            route: "/pages/proyek/rekap-progres",
            component: <RekapProgresList />,
            available: true,
          },
          {
            name: "Map",
            key: "map",
            route: "/pages/proyek/map",
            component: <Map />,
            available: true,
          },
        ],
      },
    ],
  },

  {
    type: "collapse",
    name: "Team",
    key: "team",
    icon: <Icon fontSize="small">people</Icon>,
    available: true,
    collapse: [
      {
        name: "Perusahaan List",
        key: "perusahaan-list",
        route: "/team/perusahaan/perusahaan-list",
        component: <PerusahaanList />,
        available: userStatus === "admin",
      },
      {
        name: "User baru",
        key: "new-user",
        route: "/team/users/new-user",
        component: <NewUser />,
        available: userStatus === "admin",
      },
      {
        name: "Admin List",
        key: "admin-list",
        route: "/team/admins/admin-list",
        component: <AdminList />,

        available: userStatus === "admin",
      },
      {
        name: "Users List",
        key: "users-list",
        route: "/team/users/users-list",
        component: <UsersList />,
        available: userStatus === "admin",
      },
      {
        name: "Profile Overview",
        key: "profile-overview",
        route: "/pages/profile/profile-overview",
        component: <ProfileOverview />,
        available: true,
      },
    ],
  },
];

// Export khusus untuk route SignInCover (tidak muncul di sidebar)
export const signInCoverRoute = {
  route: "/authentication/sign-in/cover",
  component: <SignInCover />,
};
export const kurvaTargetRealisasiProyekRoute = {
  route: "/pages/proyek/kurva-target-realisasi-proyek/:id",
  component: <KurvaTargetRealisasiProyek />,
};

export default routes;
